import { Button } from "@mui/material";
import { type ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

interface NavLinkWrapperProps {
  to: string;
  children: ReactNode;
  openInNewTab?: boolean;
}

export const NavLinkWrapper = ({ to, children, openInNewTab = false }: NavLinkWrapperProps) => {
  return (
    <Button
      component={RouterLink}
      rel={openInNewTab ? "noopener noreferrer" : undefined}
      sx={{
        borderRadius: "4px",
        color: "inherit",
        justifyContent: "flex-start",
        padding: {
          md: "1rem",
          sm: "0.75rem",
          xs: "0.5rem",
        },
        textAlign: "left",
        textTransform: "none",
        width: "100%",
      }}
      target={openInNewTab ? "_blank" : undefined}
      to={to}
      variant="text"
    >
      {children}
    </Button>
  );
};
